export default "__VITE_PUBLIC_ASSET__85955868__"